// Product data with DE/EN content. Prices in EUR. Demo shop only.
// Available: stand-up pouches (Standbodenbeutel). Jars (Dosen) are SOLD OUT until reproduced.
import pouchSugar from "@/assets/brand/pouch_sugar.png";
import pouchStress from "@/assets/brand/pouch_stress.png";
import pouchImmune from "@/assets/brand/pouch_immune.png";
import jarSugar from "@/assets/brand/jar_sugar.png";
import jarStress from "@/assets/brand/jar_stress.png";
import jarImmune from "@/assets/brand/jar_immune.png";
import infSugar from "@/assets/gen/inf_sugar.jpg";
import infStress from "@/assets/gen/inf_stress.jpg";
import merchHoodie from "@/assets/gen/merch_hoodie.jpg";
import accessoryShaker from "@/assets/gen/accessory_shaker.jpg";
import merchPoster from "@/assets/gen/merch_poster.jpg";
import merchCrew from "@/assets/gen/merch_crew.jpg";
import merchBucket from "@/assets/gen/merch_bucket.jpg";
import merchCap2 from "@/assets/gen/merch_cap2.jpg";
import dropTee from "@/assets/brand/drop_tee.png";
import dropTote from "@/assets/brand/drop_tote.png";
import dropMegafon from "@/assets/brand/drop_megafon.png";
import dropBanner from "@/assets/brand/drop_banner.png";
import dropCap from "@/assets/brand/drop_cap.png";
import dropButton from "@/assets/brand/drop_button.png";
import dropSticker from "@/assets/brand/drop_sticker.png";

const POUCH_DE = "Standbodenbeutel · 60 Kapseln";
const POUCH_EN = "Stand-up pouch · 60 capsules";
const JAR_DE = "Dose · 60 Kapseln";
const JAR_EN = "Jar · 60 capsules";

export const PRODUCTS = [
  {
    id: "sugar-balance",
    number: "01",
    category: "supplement",
    image: pouchSugar,
    gallery: [pouchSugar, infSugar],
    packaging: { de: POUCH_DE, en: POUCH_EN },
    altId: "sugar-jar",
    price: 29,
    accent: "#FF3366",
    tile: "#FBE3EC",
    enemy: { de: "Gegen den Zucker-Crash", en: "Beats the sugar crash" },
    name: { de: "Sugar Balance", en: "Sugar Balance" },
    claim: { de: "Blutzucker-Support*", en: "Blood Sugar Support*" },
    short: {
      de: "Schluss mit dem Nachmittags-Crash. Halte deine Cravings in Schach und bleib im Flow.",
      en: "End the afternoon crash. Keep cravings in check and stay in flow.",
    },
    long: {
      de: "15 Uhr, der Snack-Automat ruft – kennst du. Sugar Balance kombiniert Chrom, Zimt-Extrakt und Berberin, um deinen Blutzucker-Spiegel stabil zu halten und Heißhunger auszubremsen.",
      en: "3pm, the vending machine calls — you know the drill. Sugar Balance combines chromium, cinnamon extract and berberine to keep your blood sugar steady and cravings quiet.",
    },
    benefits: {
      de: ["Weniger Heißhunger-Momente", "Stabile Energie ohne Crash", "Support für den Stoffwechsel"],
      en: ["Fewer craving moments", "Steady energy, no crash", "Metabolism support"],
    },
    ingredients: { de: "Chrom · Zimt-Extrakt · Berberin · Zink", en: "Chromium · Cinnamon Extract · Berberine · Zinc" },
  },
  {
    id: "stress-balance",
    number: "02",
    category: "supplement",
    image: pouchStress,
    gallery: [pouchStress, infStress],
    packaging: { de: POUCH_DE, en: POUCH_EN },
    altId: "stress-jar",
    price: 29,
    accent: "#00CFA8",
    tile: "#F0FAB0",
    enemy: { de: "Gegen den Stress-Sturm", en: "Beats the stress storm" },
    name: { de: "Stress Balance", en: "Stress Balance" },
    claim: { de: "Cortisol-Support*", en: "Cortisol Support*" },
    short: {
      de: "Der Kopf rennt, das Herz rast. Bring dein Nervensystem zurück in Balance.",
      en: "Racing mind, racing heart. Bring your nervous system back to balance.",
    },
    long: {
      de: "Ständige Erreichbarkeit, Deadlines, Feed-Overload – der Stress-Sturm nagt an dir. Stress Balance mit Ashwagandha, L-Theanin und Magnesium senkt gefühlt den Cortisol-Pegel und bringt dich zurück in den ruhigen Fokus.",
      en: "Always-on, deadlines, feed overload — the stress storm wears you down. Stress Balance with ashwagandha, L-theanine and magnesium helps dial down cortisol and brings you back to calm focus.",
    },
    benefits: {
      de: ["Mehr innere Ruhe", "Klarer Fokus statt Overload", "Bessere Stress-Resilienz"],
      en: ["More inner calm", "Clear focus, no overload", "Better stress resilience"],
    },
    ingredients: { de: "Ashwagandha KSM-66 · L-Theanin · Magnesium · Vitamin B-Komplex", en: "Ashwagandha KSM-66 · L-Theanine · Magnesium · Vitamin B Complex" },
  },
  {
    id: "immune-booster",
    number: "03",
    category: "supplement",
    image: pouchImmune,
    packaging: { de: POUCH_DE, en: POUCH_EN },
    altId: "immune-jar",
    price: 29,
    accent: "#B084FF",
    tile: "#EBDFFB",
    enemy: { de: "Gegen die Erkältungswelle", en: "Beats the cold season" },
    name: { de: "Immune Booster", en: "Immune Booster" },
    claim: { de: "Immun-Support*", en: "Immune Support*" },
    short: {
      de: "Runtergekommen, erkältet, platt? Stärk deine Abwehr, bevor die Welle dich holt.",
      en: "Run-down, sniffly, drained? Strengthen your defences before the wave gets you.",
    },
    long: {
      de: "Zwischen U-Bahn, Büro und langen Nächten ist dein Immunsystem im Dauereinsatz. Immune Booster kombiniert Vitamin C, Zink, Holunderbeere und Echinacea für deine tägliche Abwehr-Routine.",
      en: "Between the subway, the office and late nights your immune system is on permanent duty. Immune Booster combines vitamin C, zinc, elderberry and echinacea for your daily defence routine.",
    },
    benefits: {
      de: ["Vitamin C + Zink hochdosiert", "Holunderbeere & Echinacea", "Tägliche Abwehr-Routine"],
      en: ["High-dose vitamin C + zinc", "Elderberry & echinacea", "Daily defence routine"],
    },
    ingredients: { de: "Vitamin C · Zink · Holunderbeere · Echinacea", en: "Vitamin C · Zinc · Elderberry · Echinacea" },
  },
  // ---- JARS (Dosen): sold out until reproduced ----
  {
    id: "sugar-jar",
    number: "01",
    category: "supplement",
    soldOut: true,
    altId: "sugar-balance",
    image: jarSugar,
    packaging: { de: JAR_DE, en: JAR_EN },
    price: 29,
    accent: "#FF3366",
    tile: "#FBE3EC",
    enemy: { de: "Wird neu produziert", en: "Back in production" },
    name: { de: "Sugar Balance · Dose", en: "Sugar Balance · Jar" },
    claim: { de: "Blutzucker-Support*", en: "Blood Sugar Support*" },
    short: {
      de: "Die Dose wird gerade neu produziert. Gleiche Formel – bald wieder da.",
      en: "The jar is being reproduced. Same formula — back soon.",
    },
    long: {
      de: "Unsere ikonische Dose wird gerade frisch produziert. Bis sie zurück ist, bekommst du die gleiche Sugar-Balance-Formel im praktischen Standbodenbeutel.",
      en: "Our iconic jar is being freshly produced. Until it's back, you get the same Sugar Balance formula in the handy stand-up pouch.",
    },
    benefits: {
      de: ["Weniger Heißhunger-Momente", "Stabile Energie ohne Crash", "Support für den Stoffwechsel"],
      en: ["Fewer craving moments", "Steady energy, no crash", "Metabolism support"],
    },
    ingredients: { de: "Chrom · Zimt-Extrakt · Berberin · Zink", en: "Chromium · Cinnamon Extract · Berberine · Zinc" },
  },
  {
    id: "stress-jar",
    number: "02",
    category: "supplement",
    soldOut: true,
    altId: "stress-balance",
    image: jarStress,
    packaging: { de: JAR_DE, en: JAR_EN },
    price: 29,
    accent: "#00CFA8",
    tile: "#F0FAB0",
    enemy: { de: "Wird neu produziert", en: "Back in production" },
    name: { de: "Stress Balance · Dose", en: "Stress Balance · Jar" },
    claim: { de: "Cortisol-Support*", en: "Cortisol Support*" },
    short: {
      de: "Die Dose wird gerade neu produziert. Gleiche Formel – bald wieder da.",
      en: "The jar is being reproduced. Same formula — back soon.",
    },
    long: {
      de: "Unsere ikonische Dose wird gerade frisch produziert. Bis sie zurück ist, bekommst du die gleiche Stress-Balance-Formel im praktischen Standbodenbeutel.",
      en: "Our iconic jar is being freshly produced. Until it's back, you get the same Stress Balance formula in the handy stand-up pouch.",
    },
    benefits: {
      de: ["Mehr innere Ruhe", "Klarer Fokus statt Overload", "Bessere Stress-Resilienz"],
      en: ["More inner calm", "Clear focus, no overload", "Better stress resilience"],
    },
    ingredients: { de: "Ashwagandha KSM-66 · L-Theanin · Magnesium · Vitamin B-Komplex", en: "Ashwagandha KSM-66 · L-Theanine · Magnesium · Vitamin B Complex" },
  },
  {
    id: "immune-jar",
    number: "03",
    category: "supplement",
    soldOut: true,
    altId: "immune-booster",
    image: jarImmune,
    packaging: { de: JAR_DE, en: JAR_EN },
    price: 29,
    accent: "#B084FF",
    tile: "#EBDFFB",
    enemy: { de: "Wird neu produziert", en: "Back in production" },
    name: { de: "Immune Booster · Dose", en: "Immune Booster · Jar" },
    claim: { de: "Immun-Support*", en: "Immune Support*" },
    short: {
      de: "Die Dose wird gerade neu produziert. Gleiche Formel – bald wieder da.",
      en: "The jar is being reproduced. Same formula — back soon.",
    },
    long: {
      de: "Unsere ikonische Dose wird gerade frisch produziert. Bis sie zurück ist, bekommst du die gleiche Immune-Booster-Formel im praktischen Standbodenbeutel.",
      en: "Our iconic jar is being freshly produced. Until it's back, you get the same Immune Booster formula in the handy stand-up pouch.",
    },
    benefits: {
      de: ["Vitamin C + Zink hochdosiert", "Holunderbeere & Echinacea", "Tägliche Abwehr-Routine"],
      en: ["High-dose vitamin C + zinc", "Elderberry & echinacea", "Daily defence routine"],
    },
    ingredients: { de: "Vitamin C · Zink · Holunderbeere · Echinacea", en: "Vitamin C · Zinc · Elderberry · Echinacea" },
  },
  // ---- MERCH DROP 01 (new) ----
  {
    id: "club-megafon",
    number: "D1",
    category: "accessory",
    isNew: true,
    image: dropMegafon,
    price: 19,
    accent: "#FF3366",
    tile: "#EBDFFB",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Club Megafon", en: "Club Megaphone" },
    claim: { de: "Mach Lärm für dich", en: "Make noise for yourself" },
    short: {
      de: "Gebrandetes Megafon mit FIGHT FOR YOURSELF Print. Laut sein ist gesund.",
      en: "Branded megaphone with FIGHT FOR YOURSELF print. Being loud is healthy.",
    },
    long: {
      de: "Das Club Megafon in Pink mit grünen Details und FIGHT FOR YOURSELF Print. Für laute Morgen, Club-Meetups und jeden Moment, in dem du für dich einstehst.",
      en: "The Club Megaphone in pink with green details and the FIGHT FOR YOURSELF print. For loud mornings, club meetups and every moment you stand up for yourself.",
    },
    benefits: {
      de: ["Kompakt & richtig laut", "FIGHT FOR YOURSELF Print", "Abnehmbares Spiralkabel-Mikro"],
      en: ["Compact & seriously loud", "FIGHT FOR YOURSELF print", "Detachable coil-cord mic"],
    },
    ingredients: { de: "Kunststoff · batteriebetrieben", en: "Plastic · battery powered" },
  },
  {
    id: "demo-banner",
    number: "D2",
    category: "accessory",
    isNew: true,
    image: dropBanner,
    price: 15,
    accent: "#1F4231",
    tile: "#F0FAB0",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Demo Banner", en: "Demo Banner" },
    claim: { de: "Protest-Banner", en: "Protest banner" },
    short: {
      de: "Stoffbanner mit ANTI UNHEALTHY CLUB und FIGHT FOR YOURSELF. Roll es aus.",
      en: "Fabric banner with ANTI UNHEALTHY CLUB and FIGHT FOR YOURSELF. Roll it out.",
    },
    long: {
      de: "Reißfestes Stoffbanner in Acid-Lime mit pinkem Print, Holzstab und Kordel. Häng es ins Zimmer, ins Studio oder hisse es beim nächsten Club-Meetup.",
      en: "Durable fabric banner in acid lime with pink print, wooden pole and cord. Hang it in your room, your studio or raise it at the next club meetup.",
    },
    benefits: {
      de: ["Reißfestes Gewebe", "Holzstab + Kordel", "Ca. 100 × 70 cm"],
      en: ["Durable fabric", "Wooden pole + cord", "Approx. 100 × 70 cm"],
    },
    ingredients: { de: "100 % Baumwolle", en: "100% cotton" },
  },
  {
    id: "demo-cap",
    number: "D3",
    category: "accessory",
    isNew: true,
    image: dropCap,
    price: 29,
    accent: "#FF3366",
    tile: "#FBE3EC",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Demo Cap", en: "Demo Cap" },
    claim: { de: "Club Cap", en: "Club cap" },
    short: {
      de: "Pinker Cord mit grüner Stickerei. Der Club auf dem Kopf.",
      en: "Pink corduroy with green embroidery. The club on your head.",
    },
    long: {
      de: "Strukturierte Cord-Cap in Pink mit grün gesticktem ANTI UNHEALTHY CLUB Logo. Verstellbarer Riemen, One Size.",
      en: "Structured corduroy cap in pink with the ANTI UNHEALTHY CLUB logo embroidered in green. Adjustable strap, one size.",
    },
    benefits: {
      de: ["Pinker Cord", "Grüne Stickerei", "One Size, verstellbar"],
      en: ["Pink corduroy", "Green embroidery", "One size, adjustable"],
    },
    ingredients: { de: "100 % Baumwoll-Cord", en: "100% cotton corduroy" },
  },
  {
    id: "ffy-button",
    number: "D4",
    category: "accessory",
    isNew: true,
    image: dropButton,
    price: 8,
    accent: "#FF3366",
    tile: "#FFFFFF",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Fight For Yourself Button", en: "Fight For Yourself Button" },
    claim: { de: "Ansteck-Pin · 58 mm", en: "Pin badge · 58 mm" },
    short: {
      de: "Der pinke Ansteck-Button mit Zwinker-Smiley. Louder, kinder, bolder.",
      en: "The pink pin badge with the winking smiley. Louder, kinder, bolder.",
    },
    long: {
      de: "Großer Ansteck-Button (58 mm) in Pink mit FIGHT FOR YOURSELF Statement, Zwinker-Smiley und den Zeilen „Louder. Kinder. Bolder.\" und „You got this.\" – ans Jackett, an die Club Tote, ans Cap-Band.",
      en: "Large pin badge (58 mm) in pink with the FIGHT FOR YOURSELF statement, winking smiley and the lines 'Louder. Kinder. Bolder.' and 'You got this.' — pin it on your jacket, your Club Tote, your cap band.",
    },
    benefits: {
      de: ["58 mm Durchmesser", "Mattes Finish", "Metall-Rückseite mit Nadel"],
      en: ["58 mm diameter", "Matte finish", "Metal back with pin"],
    },
    ingredients: { de: "Made in EU", en: "Made in EU" },
  },
  // ---- MERCH ----
  {
    id: "fight-tee",
    number: "M1",
    category: "merch",
    isNew: true,
    image: dropTee,
    price: 39,
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    stock: { XS: "low", S: "in", M: "in", L: "in", XL: "low", XXL: "sold" },
    accent: "#1F4231",
    tile: "#F9F8F6",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Fight Tee", en: "Fight Tee" },
    claim: { de: "Oversized Protest Shirt", en: "Oversized protest shirt" },
    short: {
      de: "Cream Oversized Tee mit FIGHT FOR YOURSELF Rückenprint. Trag das Movement.",
      en: "Cream oversized tee with FIGHT FOR YOURSELF back print. Wear the movement.",
    },
    long: {
      de: "Schweres 240g Bio-Baumwoll-Jersey, boxy Oversized-Fit, riesiger pinker Rückenprint mit der Zeile „no crash. no stress. no 3am.\" – dein Uniform-Teil für Festival, Studio und Straße.",
      en: "Heavy 240gsm organic cotton jersey, boxy oversized fit, giant pink back print with the line 'no crash. no stress. no 3am.' — your uniform for the festival, the studio and the street.",
    },
    benefits: {
      de: ["240g Bio-Baumwolle", "Unisex Oversized-Fit", "Gedruckt in der EU"],
      en: ["240gsm organic cotton", "Unisex oversized fit", "Printed in the EU"],
    },
    ingredients: { de: "Größen XS–XXL", en: "Sizes XS–XXL" },
  },
  {
    id: "auc-hoodie",
    number: "M2",
    category: "merch",
    image: merchHoodie,
    price: 69,
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    stock: { XS: "in", S: "low", M: "in", L: "sold", XL: "in", XXL: "low" },
    accent: "#B084FF",
    tile: "#EBDFFB",
    enemy: { de: "Für Fans des Movements", en: "For fans of the movement" },
    name: { de: "AUC Club Hoodie", en: "AUC Club Hoodie" },
    claim: { de: "Heavyweight 400g", en: "Heavyweight 400gsm" },
    short: {
      de: "Der Hoodie für kalte Club-Nächte und cosy Homestories.",
      en: "The hoodie for cold club nights and cosy home stories.",
    },
    long: {
      de: "Dicker 400g Fleece, weiches Innenfutter, dropped Shoulders. Wird dein neues Second-Skin.",
      en: "Thick 400gsm fleece, soft brushed inside, dropped shoulders. Your new second skin.",
    },
    benefits: {
      de: ["400g Premium-Fleece", "Dropped-Shoulder-Fit", "Kängurutasche"],
      en: ["400gsm premium fleece", "Dropped-shoulder fit", "Kangaroo pocket"],
    },
    ingredients: { de: "Größen XS–XXL", en: "Sizes XS–XXL" },
  },
  {
    id: "auc-tote",
    number: "A1",
    category: "accessory",
    isNew: true,
    image: dropTote,
    price: 24,
    accent: "#FF3366",
    tile: "#F9F8F6",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Club Tote", en: "Club Tote" },
    claim: { de: "Statement Bag", en: "Statement bag" },
    short: {
      de: "Canvas-Bag mit ANTI UNHEALTHY CLUB Print. Für Markt, Gym und Club.",
      en: "Canvas bag with ANTI UNHEALTHY CLUB print. For the market, the gym and the club.",
    },
    long: {
      de: "Robuster Natur-Canvas mit pinkem ANTI UNHEALTHY CLUB Print und kleinem „fight for yourself\"-Schriftzug. Trägt deine Supps, deine Snacks und dein Statement.",
      en: "Sturdy natural canvas with a pink ANTI UNHEALTHY CLUB print and a small 'fight for yourself' wordmark. Carries your supps, your snacks and your statement.",
    },
    benefits: {
      de: ["Schwerer Natur-Canvas", "Lange Henkel", "Innentasche"],
      en: ["Heavy natural canvas", "Long handles", "Inner pocket"],
    },
    ingredients: { de: "38 × 42 cm", en: "38 × 42 cm" },
  },
  {
    id: "auc-cap",
    number: "A2",
    category: "accessory",
    image: merchCap2,
    price: 32,
    accent: "#B084FF",
    tile: "#EBDFFB",
    enemy: { de: "Accessoire", en: "Accessory" },
    name: { de: "AUC Monogram Cap", en: "AUC Monogram Cap" },
    claim: { de: "Bestickt · Ton-in-Ton", en: "Embroidered · Tonal" },
    short: {
      de: "Cleane 6-Panel-Cap mit ton-in-ton gesticktem AUC-Monogram. Elevated, nicht laut.",
      en: "Clean 6-panel cap with a tonal embroidered AUC monogram. Elevated, not loud.",
    },
    long: {
      de: "Strukturierte 6-Panel-Cap in Bone mit dezent gesticktem AUC-Monogram und kleinem Smiley-Stempel an der Seite. Verstellbarer Riemen.",
      en: "Structured 6-panel cap in bone with a subtle embroidered AUC monogram and a small smiley stamp on the side. Adjustable strap.",
    },
    benefits: {
      de: ["Ton-in-Ton-Stickerei", "Verstellbar", "One Size"],
      en: ["Tonal embroidery", "Adjustable", "One size"],
    },
    ingredients: { de: "One Size", en: "One size" },
  },
  {
    id: "auc-shaker",
    number: "A3",
    category: "accessory",
    image: accessoryShaker,
    price: 24,
    accent: "#00CFA8",
    tile: "#D9F6FB",
    enemy: { de: "Accessoire", en: "Accessory" },
    name: { de: "Gradient Shaker", en: "Gradient Shaker" },
    claim: { de: "600ml · BPA-frei", en: "600ml · BPA-free" },
    short: {
      de: "Dein täglicher Routine-Begleiter im Farbverlauf.",
      en: "Your daily routine companion in full gradient.",
    },
    long: {
      de: "600ml BPA-freier Shaker mit Halftone-Print und auslaufsicherem Deckel. Studio-ready.",
      en: "600ml BPA-free shaker with halftone print and a leak-proof lid. Studio-ready.",
    },
    benefits: {
      de: ["600ml Volumen", "Auslaufsicher", "BPA-frei"],
      en: ["600ml volume", "Leak-proof", "BPA-free"],
    },
    ingredients: { de: "Spülmaschinenfest", en: "Dishwasher safe" },
  },
  {
    id: "positivity-crew",
    number: "M5",
    category: "merch",
    image: merchCrew,
    price: 65,
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    stock: { XS: "sold", S: "in", M: "low", L: "in", XL: "in", XXL: "sold" },
    accent: "#B084FF",
    tile: "#EBDFFB",
    enemy: { de: "Für Fans des Movements", en: "For fans of the movement" },
    name: { de: "Positivity Crewneck", en: "Positivity Crewneck" },
    claim: { de: "Heavyweight · Ton-in-Ton", en: "Heavyweight · Tonal" },
    short: {
      de: "Der ruhige Star des Drops: Ton-in-Ton-Print, premium Griff.",
      en: "The quiet hero of the drop: tonal print, premium hand-feel.",
    },
    long: {
      de: "Schwerer 400g Rundhals-Sweater mit dezentem Ton-in-Ton-Print „Positivity Movement\" und gesticktem Smiley-Stempel am Ärmel. Boxy Fit – elevated Everyday-Piece.",
      en: "Heavy 400gsm crewneck with a subtle tonal 'Positivity Movement' print and an embroidered smiley stamp on the sleeve. Boxy fit — an elevated everyday piece.",
    },
    benefits: {
      de: ["400g Bio-Baumwolle", "Ton-in-Ton-Print", "Boxy Unisex-Fit"],
      en: ["400gsm organic cotton", "Tonal print", "Boxy unisex fit"],
    },
    ingredients: { de: "Größen XS–XXL", en: "Sizes XS–XXL" },
  },
  {
    id: "auc-bucket",
    number: "A4",
    category: "accessory",
    image: merchBucket,
    price: 35,
    accent: "#00CFA8",
    tile: "#F0FAB0",
    enemy: { de: "Accessoire", en: "Accessory" },
    name: { de: "Acid Bucket Hat", en: "Acid Bucket Hat" },
    claim: { de: "Bestickt · Smiley-Stempel", en: "Embroidered · Smiley stamp" },
    short: {
      de: "Festival-Essential und Sun-Blocker in einem. Der Drop-Liebling.",
      en: "Festival essential and sun blocker in one. The drop favourite.",
    },
    long: {
      de: "Strukturierter Bucket Hat in Acid-Lime mit dezent gesticktem Smiley-Stempel. Der Hero jedes Sommer-Fits.",
      en: "Structured bucket hat in acid lime with a subtle embroidered smiley stamp. The hero of every summer fit.",
    },
    benefits: {
      de: ["Strukturierter Canvas", "Bestickter Smiley", "One Size"],
      en: ["Structured canvas", "Embroidered smiley", "One size"],
    },
    ingredients: { de: "One Size", en: "One size" },
  },
  {
    id: "fight-poster",
    number: "M3",
    category: "merch",
    image: merchPoster,
    price: 15,
    accent: "#FF6600",
    tile: "#FFE6D1",
    enemy: { de: "Für Fans des Movements", en: "For fans of the movement" },
    name: { de: "\"Fight For Yourself\" Poster", en: "\"Fight For Yourself\" Poster" },
    claim: { de: "A2 · Museumsdruck", en: "A2 · Museum print" },
    short: {
      de: "Hol dir das Statement an die Wand. Poppig, laut, jeden Morgen ein Weckruf.",
      en: "Put the statement on your wall. Poppy, loud — a wake-up call every morning.",
    },
    long: {
      de: "A2 (42 × 59 cm) Museumsdruck auf 200g mattem Papier. Kräftiger Farbverlauf, Halftone-Textur und riesige Type. Für WG-Küche, Studio-Wand oder Homeoffice.",
      en: "A2 (42 × 59 cm) museum print on 200gsm matte paper. Bold gradient, halftone texture and giant type. For the kitchen, the studio wall or the home office.",
    },
    benefits: {
      de: ["A2 Format (42 × 59 cm)", "200g mattes Papier", "Gerollt & geschützt versandt"],
      en: ["A2 format (42 × 59 cm)", "200gsm matte paper", "Ships rolled & protected"],
    },
    ingredients: { de: "Ohne Rahmen", en: "Frame not included" },
  },
  {
    id: "sticker-pack",
    number: "D5",
    category: "merch",
    isNew: true,
    image: dropSticker,
    price: 9,
    accent: "#FF3366",
    tile: "#FFFFFF",
    enemy: { de: "Merch Drop 01", en: "Merch Drop 01" },
    name: { de: "Graffiti Sticker-Set", en: "Graffiti Sticker Set" },
    claim: { de: "6 Matte Vinyl-Sticker", en: "6 matte vinyl stickers" },
    short: {
      de: "Das Graffiti-Smiley als Die-Cut: Fight For Yourself im Street-Look fürs Laptop-Setup.",
      en: "The graffiti smiley as a die-cut: Fight For Yourself in street style for your laptop setup.",
    },
    long: {
      de: "6 matte, wetterfeste Die-Cut Vinyl-Sticker im Graffiti-Look: der Fight-For-Yourself-Smiley mit Krone, Blitz, Herz und Halftone-Splashes in Pink, Lime und Orange. Rückstandsfrei ablösbar.",
      en: "6 matte, weatherproof die-cut vinyl stickers in graffiti style: the Fight For Yourself smiley with crown, bolt, heart and halftone splashes in pink, lime and orange. Residue-free removal.",
    },
    benefits: {
      de: ["6 Motive", "Matt & wetterfest", "Rückstandsfrei"],
      en: ["6 designs", "Matte & weatherproof", "Residue-free"],
    },
    ingredients: { de: "Je 5–8 cm", en: "5–8 cm each" },
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
export const BUNDLE = { id: "bundle-trio", price: 75, listPrice: 87 };
